import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import type { Dna } from '$/models/Dna.d.ts';
import { queryClient } from '@/main.tsx';

const useApplyDnaRefinement = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: (refinementId: string) => applyDnaRefinement(client, refinementId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['dna'] });
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useApplyDnaRefinement;

async function applyDnaRefinement(client: SupabaseClient, refinementId: string): Promise<BackendSuccessResponse<Dna>> {
  const { data, error } = await client.functions.invoke('apply_dna_refinement', {
    body: { refinement_id: refinementId },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
